module.exports = __webpack_public_path__ + "static/img/download-bg.d85c0ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download-bg.png
// module id = 2NnO
// module chunks = 1